'use client';

import { useRef, useLayoutEffect } from "react";
import { MAX_TOAST_NOTIFICATIONS } from "./constants.js";
function useToastManagerUpdate(toastManager, toastNotifications, onAfterStateChange) {
  const mountedRef = useRef(/* @__PURE__ */ new WeakSet());
  useLayoutEffect(() => {
    onAfterStateChange();
    toastNotifications.forEach((toast) => {
      if (mountedRef.current.has(toast)) return;
      toastManager.onToastMount(toast);
      mountedRef.current.add(toast);
    });
    if (toastNotifications.length < MAX_TOAST_NOTIFICATIONS) {
      toastManager.onReadyForMore();
    }
  }, [toastNotifications]);
}
export {
  useToastManagerUpdate
};
